'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineQuotationEditor = require('./components/InlineQuotationEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineQuotationEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/inline-quotation-editor/index.js
// module id = 1026
// module chunks = 4